import localforage from 'localforage'

const DbName = process.env.REACT_APP_INDEXED_DB_NAME
const version = parseFloat(process.env.REACT_APP_INDEXED_DB_VERSION || '2')
const storeName = process.env.REACT_APP_INDEXED_DB_STORE_NAME
const description = process.env.REACT_APP_INDEXED_DB_STORE_DESCRIPTION

export const Keys = {
    WelcomeModalSeen: 'welcome_modal_seen',
    CurrentPathId: 'current_path_id',
    QuizResults: 'quiz_results',
}

if (typeof window !== 'undefined' && DbName && version && storeName && description) {
    localforage.config({
        driver: localforage.INDEXEDDB,
        name: process.env.REACT_APP_INDEXED_DB_NAME,
        version: parseFloat(process.env.REACT_APP_INDEXED_DB_VERSION || '2'),
        storeName: process.env.REACT_APP_INDEXED_DB_STORE_NAME,
        description: process.env.REACT_APP_INDEXED_DB_STORE_DESCRIPTION,
    })
}

export const get = (key: string, callback?: () => void) => {
    if (typeof window !== 'undefined') {
        return localforage.getItem(key, callback)
    }
}

export const set = (key: string, data: string, callback?: () => void) => {
    if (typeof window !== 'undefined') {
        return localforage.setItem(key, data, callback)
    }
}

export const del = (key: string, callback?: () => void) => {
    if (typeof window !== 'undefined') {
        return localforage.removeItem(key, callback)
    }
}
